/* ============================================================
   KIT PDP 247. Fase 1.

   Tiga pekerjaan saja:
   1. klik opsi mengganti varian, plus URL ikut ?variant=
   2. harga, tombol, dan penanda terpilih ikut berubah
   3. add to cart lewat /cart/add.js lalu buka cart drawer theme

   Slider galeri TIDAK diurus di sini. Itu sudah ditangani kit-247.js yang
   dimuat berdampingan, lewat listener tingkat document ke .kit-247__slides.

   Harga tidak diformat di sini. Semua varian sudah dirender lewat filter
   money di Liquid, jadi format mata uang toko tidak pernah salah.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-kit-pdp]');
  if (!root) return;

  var jsonEl = root.querySelector('[data-kp-json]');
  if (!jsonEl) return;

  var data;
  try {
    data = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;   // JSON rusak, biarkan form jalan sebagai POST biasa
  }

  var variants = data.variants || [];
  var form = root.querySelector('[data-kp-form]');
  var idInput = root.querySelector('[data-kp-variant-id]');
  var atc = root.querySelector('[data-kp-atc]');
  var atcText = root.querySelector('[data-kp-atc-text]');
  var priceEl = root.querySelector('[data-kp-price]');
  var compareEl = root.querySelector('[data-kp-compare]');
  var slides = root.querySelector('[data-kp-slides]');
  var tombolOpsi = root.querySelectorAll('[data-kp-opt]');
  var skuWrap = root.querySelector('[data-kp-sku-wrap]');
  var skuEl = root.querySelector('[data-kp-sku]');
  var slideEls = slides ? slides.querySelectorAll('.kit-pdp__slide') : [];
  var dots = root.querySelectorAll('[data-kp-dots] .kit-pdp__dot');
  var thumbs = root.querySelectorAll('[data-kp-thumb]');

  /* Lebar SATU slide, bukan lebar wadahnya.

     Di desktop wadah galeri memuat DUA gambar sekaligus, jadi
     slides.clientWidth bernilai dua slide. Memakainya untuk menghitung
     gambar aktif akan menyalakan titik dan thumbnail yang salah, dan
     lompatan galeri waktu varian diganti akan meleset satu gambar.

     offsetWidth dibaca setiap dipanggil, tidak di-cache: nilainya berubah
     waktu jendela diubah ukurannya melewati 768. */
  function lebarSlide() {
    if (slideEls.length) return slideEls[0].offsetWidth || 1;
    return (slides && slides.clientWidth) || 1;
  }

  /* Indeks DOM, sudah termasuk klon. Untuk titik dan thumbnail harus
     dilewatkan indeksNyata() dulu. */
  function indeksAktif() {
    if (!slides) return 0;
    return Math.round(slides.scrollLeft / lebarSlide());
  }

  /* ============================================================
     GALERI BERPUTAR TANPA UJUNG.

     Satu set penuh dikloning di depan dan satu set lagi di belakang, lalu
     posisi awal ditaruh di set TENGAH. Begitu guliran berhenti di luar set
     tengah, scrollLeft digeser tepat sejauh satu set. Karena ketiga set
     identik, geseran itu tidak terlihat sama sekali: yang tampil sesudah
     geseran sama persis dengan yang tampil sebelumnya.

     Kenapa satu set penuh sudah cukup, bukan sekadar satu dua slide:
     jumlah klon di tiap sisi otomatis sama dengan jumlah gambar asli, jadi
     produk bergambar dua tetap punya dua klon di kiri dan dua di kanan.
     Layar desktop memuat dua gambar, jadi tidak pernah ada bidang kosong
     di tengah putaran.

     Produk bergambar SATU tidak diloop dan tidak dikloning sama sekali.
     ============================================================ */
  var jumlahAsli = slideEls.length;
  var berputar = !!slides && jumlahAsli > 1;

  function bikinKlon(el) {
    var k = el.cloneNode(true);
    /* Klon dilepas dari pembacaan layar. Isinya cuma <img>, tidak ada
       yang bisa difokus, jadi urutan fokus keyboard sudah bersih sendiri. */
    k.setAttribute('aria-hidden', 'true');
    k.setAttribute('data-kp-klon', '');
    /* data-kp-media dilepas supaya pencarian gambar varian di terapkan()
       selalu menemukan slide ASLI, bukan klon. */
    k.removeAttribute('data-kp-media');
    var img = k.querySelector('img');
    /* src dan srcset sengaja dibiarkan persis sama. URL yang identik
       berarti browser memakai gambar yang sudah diunduh, tidak ada
       permintaan jaringan tambahan. fetchpriority dilepas supaya klon
       tidak ikut berebut antrean dengan gambar pertama yang asli. */
    if (img) img.removeAttribute('fetchpriority');
    return k;
  }

  /* Lebar satu set asli, diambil dari SELISIH OFFSET klon pertama dan
     slide asli pertama, bukan dari lebar slide dikali jumlah. Selisih
     offset mengikuti tata letak sebenarnya, jadi tetap tepat walau lebar
     slide jatuh di angka pecahan. */
  function panjangSet() {
    if (!berputar || !slides.firstElementChild) return 0;
    return slideEls[0].offsetLeft - slides.firstElementChild.offsetLeft;
  }

  /* Penulisan scrollLeft yang dijamin seketika. theme memasang
     scroll-behavior smooth di elemen html dan itu bisa terwarisi ke sini,
     yang akan mengubah geseran diam diam jadi animasi yang justru terlihat. */
  function setInstan(x) {
    if (!slides) return;
    var simpan = slides.style.scrollBehavior;
    slides.style.scrollBehavior = 'auto';
    slides.scrollLeft = x;
    slides.style.scrollBehavior = simpan;
  }

  /* Kembalikan posisi ke set tengah, yaitu rentang [c, 2c). */
  function keSetTengah() {
    if (!berputar) return;
    var c = panjangSet();
    if (c <= 0) return;
    var x = slides.scrollLeft;
    while (x < c) x += c;
    while (x >= 2 * c) x -= c;
    if (Math.abs(x - slides.scrollLeft) > 0.5) setInstan(x);
  }

  /* Penormalan SELALU ditunda sampai guliran benar benar berhenti.

     Ini bagian yang menentukan mulus atau patah. Kalau scrollLeft digeser
     di tengah animasi, baik animasi smooth milik pelepasan tarikan maupun
     sisa dorongan jari atau trackpad, animasinya mati di tempat dan
     PERSIS itu yang terasa sebagai pengulangan yang patah.

     Guliran yang masih berjalan terus memicu event scroll, jadi pewaktunya
     ikut mundur terus dan baru menyala sesudah semuanya diam. Landasannya
     satu set penuh di tiap sisi, dua sampai empat gambar, jadi satu ayunan
     tidak akan sempat menabrak ujung sebelum penormalan sempat jalan. */
  var jamDiam = null;
  function jadwalNormal() {
    if (!berputar) return;
    clearTimeout(jamDiam);
    jamDiam = setTimeout(function () {
      // jangan potong tarikan mouse yang sedang berlangsung
      if (slides.classList.contains('is-dragging')) { jadwalNormal(); return; }
      keSetTengah();
    }, 200);
  }

  /* Indeks DOM ke indeks gambar ASLI. Klon tidak boleh muncul sebagai
     titik tambahan, jadi indeksnya dilipat balik ke rentang aslinya.
     Modulo ditulis dua kali karena sisa bagi negatif di JS ikut negatif. */
  function indeksNyata(i) {
    if (!berputar) return Math.min(Math.max(i, 0), Math.max(jumlahAsli - 1, 0));
    return ((i - jumlahAsli) % jumlahAsli + jumlahAsli) % jumlahAsli;
  }

  if (berputar) {
    var depan = document.createDocumentFragment();
    var belakang = document.createDocumentFragment();
    for (var kl = 0; kl < jumlahAsli; kl++) {
      depan.appendChild(bikinKlon(slideEls[kl]));
      belakang.appendChild(bikinKlon(slideEls[kl]));
    }
    slides.insertBefore(depan, slides.firstChild);
    slides.appendChild(belakang);
    keSetTengah();
    /* Sebagian browser mengembalikan posisi gulir sendiri sesudah load.
       Dipasang sekali lagi di situ, bukan diulang ulang. */
    window.addEventListener('load', keSetTengah);
  }

  var pilihan = (data.selected || []).slice();

  /* ---------- pencarian varian ---------- */

  function cariVarian(kombinasi) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var cocok = true;
      for (var j = 0; j < kombinasi.length; j++) {
        if (v.options[j] !== kombinasi[j]) { cocok = false; break; }
      }
      if (cocok) return v;
    }
    return null;
  }

  /* Ada varian TERSEDIA kalau posisi pos diisi nilai ini, sementara posisi
     lain memakai pilihan sekarang. Dipakai untuk menandai ukuran habis. */
  function adaStok(pos, nilai) {
    var uji = pilihan.slice();
    uji[pos] = nilai;
    var v = cariVarian(uji);
    return v ? v.available : false;
  }

  /* ---------- terapkan varian ke halaman ---------- */

  function terapkan(v) {
    if (idInput) idInput.value = v.id;

    /* URL ikut berubah supaya link bisa dibagikan dan tombol back tetap
       masuk akal. replaceState, bukan pushState: tiap klik ukuran jangan
       menambah satu langkah riwayat. */
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({ id: v.id }, '', url.toString());
    } catch (e) {}

    /* Umumkan pergantian varian. Mengisi idInput.value lewat kode TIDAK
       memicu event change, jadi tanpa baris ini tidak ada yang tahu ukuran
       berganti. Korbannya kit-stock.js: badge stok per lokasi cuma digambar
       ulang saat mendengar change dari dalam form /cart/add, sehingga badge
       tertahan di varian awal dan baru benar setelah halaman di-refresh
       (saat itu varian dibaca dari ?variant= di URL).

       Event change di input name="id", bukan event khusus buatan sendiri,
       karena itu sinyal yang juga dipantau app pihak ketiga. Aman dari loop:
       kit-pdp.js tidak punya listener change. Aman dari efek samping theme:
       kelima listener change di theme.js terpasang langsung ke elemen lain
       (catatan keranjang, negara, filter, langganan, upsell), tidak ada yang
       di level dokumen. Dikirim setelah value dan URL terisi supaya
       pendengarnya membaca varian yang baru. */
    if (idInput) idInput.dispatchEvent(new Event('change', { bubbles: true }));

    /* harga. innerHTML karena filter money bisa memuat entitas seperti &nbsp; */
    if (priceEl && v.price) priceEl.innerHTML = v.price;
    if (compareEl) {
      if (v.compare) {
        compareEl.innerHTML = v.compare;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    /* SKU. Wadahnya sudah ada di DOM sejak awal kalau ADA varian yang
       punya SKU, jadi di sini tinggal isi atau sembunyikan. Varian yang
       SKU-nya kosong menyembunyikan barisnya, bukan menampilkan
       "SKU" tanpa nilai. */
    if (skuWrap && skuEl) {
      if (v.sku) {
        skuEl.textContent = v.sku;
        skuWrap.hidden = false;
      } else {
        skuWrap.hidden = true;
      }
    }

    // tombol add to cart
    if (atc) {
      atc.disabled = !v.available;
      if (atcText) {
        atcText.textContent = v.available
          ? (atc.getAttribute('data-add-text') || 'Add to Cart')
          : (atc.getAttribute('data-sold-text') || 'Sold Out');
      }
    }

    // penanda terpilih, penanda habis, dan label nilai terpilih
    for (var i = 0; i < tombolOpsi.length; i++) {
      var b = tombolOpsi[i];
      var pos = parseInt(b.getAttribute('data-kp-pos'), 10);
      var nilai = b.getAttribute('data-kp-value');

      var terpilih = pilihan[pos] === nilai;
      b.classList.toggle('is-selected', terpilih);
      b.setAttribute('aria-pressed', terpilih ? 'true' : 'false');

      // swatch warna tidak pernah dimatikan, hanya tombol ukuran
      if (b.classList.contains('kit-pdp__size')) {
        var stok = adaStok(pos, nilai);
        b.classList.toggle('is-out', !stok);
        b.disabled = !stok;
        if (!stok) {
          b.setAttribute('aria-disabled', 'true');
        } else {
          b.removeAttribute('aria-disabled');
        }
      }
    }

    root.querySelectorAll('[data-kp-selected]').forEach(function (el) {
      var pos = parseInt(el.getAttribute('data-kp-selected'), 10);
      if (pilihan[pos]) el.textContent = pilihan[pos];
    });

    /* Galeri lompat ke gambar varian, kalau varian punya gambar sendiri.
       Klon sudah dilepas data-kp-media-nya, jadi yang ketemu di sini pasti
       slide ASLI. Tujuannya tetap lewat tujuanNyata() supaya yang dipilih
       salinan terdekat, bukan selalu yang di set tengah. */
    if (v.media && slides) {
      var slide = slides.querySelector('[data-kp-media="' + v.media + '"]');
      if (slide) {
        var k = [].indexOf.call(slideEls, slide);
        var tujuan = k >= 0 ? tujuanNyata(k) : null;
        if (tujuan != null && Math.abs(slides.scrollLeft - tujuan) > lebarSlide() / 4) {
          gulir(tujuan);
        }
      }
    }
  }

  /* ---------- klik opsi ---------- */

  function pilih(pos, nilai) {
    var uji = pilihan.slice();
    uji[pos] = nilai;

    var v = cariVarian(uji);
    if (!v) {
      /* Kombinasi ini tidak ada. Ambil varian pertama yang memakai nilai
         tadi, lalu ikut seluruh opsinya. Tanpa ini, mengganti warna ke
         warna yang tidak punya ukuran sekarang akan mengunci halaman. */
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options[pos] === nilai) { v = variants[i]; break; }
      }
    }
    if (!v) return;

    pilihan = v.options.slice();
    terapkan(v);
  }

  for (var i = 0; i < tombolOpsi.length; i++) {
    tombolOpsi[i].addEventListener('click', function (e) {
      e.preventDefault();
      if (this.disabled) return;
      pilih(parseInt(this.getAttribute('data-kp-pos'), 10), this.getAttribute('data-kp-value'));
    });
  }

  /* ---------- titik penanda dan rel thumbnail ---------- */

  /* Titik di halaman ini SENGAJA bernama data-kp-dots, bukan
     data-kit247-dots, supaya kit-247.js melepasnya. Rumus di sana
     memakai lebar wadah, dan itu benar di kartu koleksi karena satu
     layar sama dengan satu gambar. Di sini satu layar memuat dua. */
  /* Titik dan thumbnail sama sama menandai SATU gambar saja, yaitu yang
     paling kiri di layar. Permintaan klien.

     Sempat dibuat menandai semua yang terlihat, waktu galerinya belum
     berputar. Alasannya waktu itu nyata: dengan dua gambar sekaligus,
     slide terakhir tidak pernah bisa berada di tepi kiri, jadi penanda
     terakhir mati selamanya. Sejak galerinya berputar tanpa ujung, setiap
     gambar pasti kebagian giliran jadi yang paling kiri, jadi alasan itu
     hilang sendiri.

     indeksAktif mengembalikan indeks DOM yang sudah termasuk klon, jadi
     harus dilipat dulu ke indeks ASLI lewat indeksNyata. Tanpa itu,
     gambar yang sedang tampil dari set klon tidak akan menyalakan
     penanda mana pun. */
  function tandai() {
    var kiri = indeksNyata(indeksAktif());
    var i;
    for (i = 0; i < dots.length; i++) dots[i].classList.remove('is-on');
    for (i = 0; i < thumbs.length; i++) thumbs[i].classList.remove('is-on');
    if (dots[kiri]) dots[kiri].classList.add('is-on');
    if (thumbs[kiri]) thumbs[kiri].classList.add('is-on');
  }

  /* Posisi gulir menuju gambar asli ke-k, memilih SALINAN TERDEKAT.
     Tanpa ini, klik thumbnail waktu posisi sedang di tepi set tengah bisa
     menggulir melintasi hampir seluruh strip, padahal ada salinan yang
     sama persis tepat di sebelah. Calon di luar jangkauan gulir dibuang,
     karena scrollTo akan menjepitnya ke posisi yang tidak sejajar snap. */
  function tujuanNyata(k) {
    if (!slides || !slideEls[k]) return null;
    var dasar = slideEls[k].offsetLeft - slides.offsetLeft;
    if (!berputar) return dasar;

    var c = panjangSet();
    var maks = slides.scrollWidth - slides.clientWidth;
    var calon = [dasar - c, dasar, dasar + c];
    var x = slides.scrollLeft, pilih = dasar, jarak = Infinity;
    for (var i = 0; i < calon.length; i++) {
      if (calon[i] < 0 || calon[i] > maks) continue;
      var d = Math.abs(calon[i] - x);
      if (d < jarak) { jarak = d; pilih = calon[i]; }
    }
    return pilih;
  }

  function gulir(x) {
    if (!slides || x == null) return;
    try {
      slides.scrollTo({ left: x, behavior: 'smooth' });
    } catch (e) {
      slides.scrollLeft = x;
    }
  }

  function keSlide(n) {
    keSetTengah();
    gulir(tujuanNyata(n));
  }

  if (slides) {
    /* Tanpa throttle. Isinya cuma classList.toggle pada belasan elemen,
       dan toggle ke nilai yang sama tidak memicu gambar ulang. rAF
       sengaja dihindari di sini: pernah terbukti beku di sebagian
       konteks pratinjau dan bikin penanda berhenti hidup. */
    slides.addEventListener('scroll', function () {
      tandai();
      jadwalNormal();
    }, { passive: true });

    /* Lebar slide berubah waktu jendela melewati 768, jadi posisi lama
       jatuh di tengah tengah dua slide. Dinormalkan lewat pewaktu yang
       sama supaya tidak ada dua jalur yang saling mendahului. */
    window.addEventListener('resize', function () {
      tandai();
      jadwalNormal();
    });
  }

  for (var t = 0; t < thumbs.length; t++) {
    thumbs[t].addEventListener('click', function () {
      keSlide(parseInt(this.getAttribute('data-kp-thumb'), 10));
    });
  }

  /* ---------- panah mundur ---------- */

  /* Satu panah saja, arah kiri, permintaan tegas klien. Maju sudah
     dilayani tarikan mouse, ayunan jari, dan rel thumbnail.

     Posisi dinormalkan DULU supaya scrollLeft dijamin berada di set
     tengah, [c, 2c). Karena c sama dengan jumlahAsli dikali lebar slide
     dan jumlahAsli minimal 2, mundur satu slide dari situ tidak pernah
     bisa jatuh di bawah nol. Penjepit di bawah cuma pengaman. */
  /* ---------- akordeon informasi produk ---------- */

  /* <details> bawaan tidak bisa dianimasikan: isinya muncul dan hilang
     seketika. Jadi buka tutupnya diambil alih di sini, tingginya
     dianimasikan dari nol ke setinggi isi dan sebaliknya.

     Karena JS sudah memegang kendali, aturan hanya satu boleh terbuka
     juga ditangani di sini. Atribut name pada <details> sengaja TIDAK
     dipakai walaupun bisa menutup saudaranya sendiri, karena browser
     menutupnya seketika tanpa animasi dan itu justru terlihat melompat
     tepat di saat yang lain sedang meluncur. */
  var accRows = root.querySelectorAll('.kit-pdp__acc-row');

  if (accRows.length) {
    /* Harus sama dengan durasi transition di kit-pdp.css. Nol kalau
       pengunjung minta gerak dikurangi, supaya pembersihannya langsung
       dan barisnya tidak tersangkut setengah terbuka. */
    var ACC_MS = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 0 : 350;

    var accIsi = function (row) { return row.querySelector('.kit-pdp__acc-body'); };

    /* Durasi IKUT JARAK TEMPUH, bukan angka tetap.

       Ini memperbaiki keluhan nyata: akordeon berisi deskripsi panjang
       terasa membuka mendadak. Penyebabnya bukan animasinya mati, tapi
       kecepatannya. Terukur di produk Satisfy: baris Specifications
       bergerak 150px, baris Product Description bergerak 1563px, dan
       dengan durasi tetap 350ms yang panjang melaju 4500 piksel per
       detik. Di kecepatan itu mata membacanya sebagai lompatan.

       Dipakai akar kuadrat, bukan perbandingan lurus. Lurus membuat yang
       panjang jadi kelewat lambat: 1563px akan minta 3.6 detik pada
       kecepatan yang enak untuk 150px. Akar kuadrat mengikuti cara mata
       menilai kecepatan, jarak sepuluh kali lipat cukup dibayar durasi
       tiga kali lipat.

         150px  -> 347ms   (1160 px/detik)
         1563px -> 674ms   (2320 px/detik)

       Dibatasi 700ms di atas supaya tidak pernah terasa lamban, dan
       240ms di bawah supaya baris pendek tetap terbaca sebagai gerakan. */
    var durasiAcc = function (jarak) {
      if (!ACC_MS) return 0;
      var d = 200 + Math.sqrt(Math.abs(jarak)) * 12;
      if (d > 700) d = 700;
      if (d < 240) d = 240;
      return Math.round(d);
    };

    /* Pembersihan dijadwalkan pakai pewaktu, bukan transitionend.

       transitionend tidak pernah menyala kalau transisinya dimatikan,
       entah oleh prefers-reduced-motion atau karena tingginya kebetulan
       tidak berubah. Kalau itu terjadi, baris yang sedang ditutup akan
       tersangkut dengan atribut open masih terpasang dan tinggi terkunci
       di nol, jadi tidak bisa dibuka lagi sama sekali. */
    var beresAcc = function (row, terbuka, ms) {
      clearTimeout(row.kpJamAcc);
      row.kpJamAcc = setTimeout(function () {
        var body = accIsi(row);
        if (!body) return;
        if (!terbuka) row.open = false;
        /* durasi inline dilepas supaya nilai dari CSS berlaku lagi
           kalau suatu saat ada yang menganimasikan elemen ini */
        body.style.transitionDuration = '';
        /* Tinggi dilepas supaya kembali auto. Kalau dibiarkan terkunci di
           angka piksel, isi yang tumbuh belakangan, misalnya gambar yang
           baru selesai dimuat, akan terpotong. */
        body.style.height = '';
      }, ms + 30);
    };

    var bukaAcc = function (row) {
      var body = accIsi(row);
      if (!body) return;
      row.classList.add('is-open');
      row.open = true;
      body.style.height = '0px';
      void body.offsetHeight;
      /* scrollHeight dibaca SESUDAH tingginya dipatok nol, dan itu tetap
         benar: overflow hidden membuat scrollHeight melaporkan tinggi isi
         sebenarnya, bukan tinggi kotak yang sedang dikecilkan. */
      var tinggi = body.scrollHeight;
      var ms = durasiAcc(tinggi);
      body.style.transitionDuration = ms + 'ms';
      body.style.height = tinggi + 'px';
      beresAcc(row, true, ms);
    };

    var tutupAcc = function (row) {
      var body = accIsi(row);
      if (!body) return;
      row.classList.remove('is-open');
      var tinggi = body.scrollHeight;
      var ms = durasiAcc(tinggi);
      body.style.transitionDuration = ms + 'ms';
      body.style.height = tinggi + 'px';
      void body.offsetHeight;
      body.style.height = '0px';
      beresAcc(row, false, ms);
    };

    for (var ar = 0; ar < accRows.length; ar++) {
      (function (row) {
        var kepala = row.querySelector('summary');
        if (!kepala) return;

        kepala.addEventListener('click', function (e) {
          /* Wajib. Tanpa ini browser ikut menoggle open sendiri, dan
             togglenya bertabrakan dengan yang dikerjakan di sini. */
          e.preventDefault();

          if (row.classList.contains('is-open')) {
            tutupAcc(row);
            return;
          }

          for (var k = 0; k < accRows.length; k++) {
            if (accRows[k] !== row && accRows[k].classList.contains('is-open')) {
              tutupAcc(accRows[k]);
            }
          }
          bukaAcc(row);
        });
      })(accRows[ar]);
    }
  }

  /* ---------- review Judge.me ---------- */

  /* Data diambil LANGSUNG dari Judge.me tiap halaman dibuka, bukan dari
     metafield. Keputusan Calvin.

     Endpoint reviews_for_widget itu yang dipakai widget Judge.me sendiri.
     Sudah diuji dari storefront: status 200, CORS lolos, tanpa token.
     Dia mengembalikan JSON berisi HTML mereka, lalu kita ambil datanya
     saja dan menggambar ulang kartunya dengan gaya panel KIT. Tidak ada
     satu pun kelas jdgm- yang ikut tampil.

     Risiko yang harus disebut: itu endpoint internal widget mereka, bukan
     API publik berdokumentasi. Kalau suatu saat berubah, fetch gagal dan
     barisnya jatuh ke keadaan kosong. Buy box tidak ikut rusak. */
  var revBox = root.querySelector('[data-kp-reviews]');

  if (revBox && window.fetch) {
    var revCount = root.querySelector('[data-kp-rev-count]');
    var revPid = revBox.getAttribute('data-product-id');
    var revShop = revBox.getAttribute('data-shop');
    var revLimit = parseInt(revBox.getAttribute('data-limit'), 10) || 5;

    /* Field Judge.me dicari lewat DAFTAR selektor, bukan satu selektor.

       Alasannya jujur: saya belum pernah melihat satu pun HTML review
       asli dari toko ini, semua produk yang bisa diuji nol review dan
       satu satunya yang punya terhalang rate limit Shopify. Jadi
       pemetaan field ini dibangun tahan banting: kalau selektor pertama
       meleset, yang berikutnya dicoba, dan kalau semua meleset field itu
       dilewati tanpa merusak kartunya. */
    var revCari = function (el, sels) {
      for (var i = 0; i < sels.length; i++) {
        var n = el.querySelector(sels[i]);
        if (!n) continue;
        var t = (n.getAttribute('data-content') || n.textContent || '').trim();
        if (t) return t;
      }
      return '';
    };

    /* Tanggal. textContent elemen <time> KOSONG di HTML yang dikirim
       Judge.me, kelasnya jdgm-spinner dan baru diisi skrip mereka sesudah
       widget mereka sendiri jalan. Kita tidak memuat widget itu, jadi
       nilainya harus diambil dari atribut.

       datetime dipakai lebih dulu karena formatnya ISO. data-content
       cadangannya, isinya "2026-03-17 10:12:42 UTC" yang perlu dirapikan
       dulu supaya bisa dibaca Date. */
    var revBulan = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    var revTanggal = function (el) {
      var n = el.querySelector('.jdgm-rev__timestamp');
      if (!n) return '';
      var iso = n.getAttribute('datetime') || n.getAttribute('data-content') || '';
      if (!iso) return '';
      var d = new Date(iso.replace(' UTC', 'Z').replace(' ', 'T'));
      if (isNaN(d.getTime())) return '';
      return d.getDate() + ' ' + revBulan[d.getMonth()] + ' ' + d.getFullYear();
    };

    /* Isi review bisa berisi beberapa paragraf. textContent menyambungnya
       tanpa spasi, jadi "bagus" dan "sekali" jadi "bagussekali". */
    var revIsi = function (el) {
      var b = el.querySelector('.jdgm-rev__body');
      if (!b) return '';
      var par = b.querySelectorAll('p');
      if (!par.length) return (b.textContent || '').trim();
      var bagian = [];
      for (var i = 0; i < par.length; i++) {
        var t = (par[i].textContent || '').trim();
        if (t) bagian.push(t);
      }
      return bagian.join(' ');
    };

    var revSkor = function (el) {
      var n = el.querySelector('[data-score]');
      if (n) {
        var v = parseFloat(n.getAttribute('data-score'));
        if (!isNaN(v)) return Math.round(v);
      }
      var penuh = el.querySelectorAll('.jdgm-star.jdgm--on, .jdgm--star.jdgm--on');
      return penuh.length || 0;
    };

    /* textContent, bukan innerHTML. Isi review ditulis pengunjung, jadi
       diperlakukan sebagai teks. Menyuntikkannya sebagai HTML membuka
       jalan skrip asing masuk ke halaman produk. */
    var revAman = function (t) {
      var d = document.createElement('div');
      d.textContent = t;
      return d.innerHTML;
    };

    var revBintang = function (skor) {
      var out = '';
      for (var i = 1; i <= 5; i++) {
        out += '<span class="kit-pdp__rev-star' + (i <= skor ? ' is-on' : '') + '" aria-hidden="true">\u2605</span>';
      }
      return '<span class="kit-pdp__rev-stars" role="img" aria-label="' + skor + ' of 5">' + out + '</span>';
    };

    /* Keadaan kosong. Tautannya memicu tombol Judge.me yang SUDAH ada di
       halaman, bukan membangun form sendiri. Sudah diuji: klik pada
       .jdgm-write-rev-link membuka modal mereka dengan produk yang benar
       sudah terisi. Kalau tombol itu tidak ada, tautannya tidak dirender
       sama sekali. Tautan mati lebih buruk daripada tidak ada tautan. */
    var revKosong = function () {
      var adaForm = !!document.querySelector('.jdgm-write-rev-link');
      revBox.innerHTML =
        '<p class="kit-pdp__rev-empty">Be the first to review this product.' +
        (adaForm ? ' <a href="#" class="kit-pdp__rev-write" data-kp-rev-write>Write a review</a>' : '') +
        '</p>';
    };

    revBox.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-kp-rev-write]');
      if (!a) return;
      e.preventDefault();
      var btn = document.querySelector('.jdgm-write-rev-link');
      if (btn) btn.click();
    });

    var revGambar = function (daftar) {
      var kartu = '';
      for (var i = 0; i < daftar.length; i++) {
        var r = daftar[i];
        var skor = revSkor(r);
        var judul = revCari(r, ['.jdgm-rev__title']);
        var isi = revIsi(r);
        var nama = revCari(r, ['.jdgm-rev__author', '.jdgm-rev__buyer-name']);
        var tgl = revTanggal(r);
        /* Dibaca dari data-verified-buyer di elemen AKAR.

           Versi pertama saya membaca .jdgm-rev__icon, dan itu salah
           besar: elemen itu cuma avatar huruf awal nama, dan ADA di
           setiap review. Akibatnya semua review dilabeli Verified
           walaupun bukan pembeli terverifikasi. Itu klaim palsu, bukan
           cuma salah tampilan. Ketahuan waktu membaca HTML review
           sungguhan, bukan waktu menulis kodenya. */
        var verif = r.getAttribute('data-verified-buyer') === 'true';

        kartu +=
          '<div class="kit-247__slide kit-pdp__rev-slide"><div class="kit-pdp__rev-card">' +
            revBintang(skor) +
            (judul ? '<h4 class="kit-pdp__rev-title">' + revAman(judul) + '</h4>' : '') +
            (isi ? '<p class="kit-pdp__rev-body">' + revAman(isi) + '</p>' : '') +
            '<p class="kit-pdp__rev-meta">' +
              (nama ? '<span class="kit-pdp__rev-name">' + revAman(nama) + '</span>' : '') +
              (verif ? '<span class="kit-pdp__rev-verified">Verified</span>' : '') +
              (tgl ? '<span class="kit-pdp__rev-date">' + revAman(tgl) + '</span>' : '') +
            '</p>' +
          '</div></div>';
      }

      var titik = '';
      if (daftar.length > 1) {
        titik = '<div class="kit-pdp__rev-dots kit-247__dots" data-kit247-dots>';
        for (var d = 0; d < daftar.length; d++) {
          titik += '<span class="kit-247__dot' + (d === 0 ? ' is-on' : '') + '"></span>';
        }
        titik += '</div>';
      }

      /* Kelas .kit-247__slides dan .kit-247__slide dipakai ulang APA
         ADANYA supaya tarikan mouse dan sinkronisasi titik milik
         kit-247.js langsung berlaku. Dua duanya listener tingkat
         document, jadi tetap melayani isi yang baru dirender seperti
         ini. Gaya khas galeri yang ikut terbawa dinetralkan di
         kit-pdp.css, dijelaskan di sana. */
      revBox.innerHTML =
        '<div class="kit-247__slides kit-pdp__rev-track">' + kartu + '</div>' + titik;

      if (revCount) {
        revCount.textContent = String(daftar.length);
        revCount.hidden = false;
      }
    };

    var revUrl = 'https://judge.me/reviews/reviews_for_widget' +
      '?url=' + encodeURIComponent(revShop) +
      '&shop_domain=' + encodeURIComponent(revShop) +
      '&platform=shopify&page=1' +
      '&per_page=' + revLimit +
      '&product_id=' + encodeURIComponent(revPid);

    fetch(revUrl, { headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var d = document.createElement('div');
        d.innerHTML = j && j.html ? j.html : '';
        var daftar = d.querySelectorAll('.jdgm-rev');
        if (!daftar.length) { revKosong(); return; }
        revGambar(daftar);
      })
      .catch(function () { revKosong(); });
  }

  /* ---------- laci size chart ---------- */

  /* Datanya warisan desain lama, cuma tampilannya yang baru. Buka tutupnya
     ditulis di sini dan tidak memakai skrip milik sections/product.liquid,
     karena section itu memang tidak dirender di halaman ini. */
  var scBox = root.querySelector('[data-kp-sc]');
  if (scBox) {
    var scJam = null;

    var bukaSC = function () {
      clearTimeout(scJam);
      scBox.hidden = false;
      /* Forced reflow. Kelihatan tidak berguna dan sering kena lint, tapi
         tanpa baris ini browser menggabungkan pelepasan hidden dengan
         penambahan kelas ke dalam satu perhitungan gaya. Akibatnya
         transisinya tidak pernah punya keadaan awal, dan lacinya muncul
         mendadak tanpa meluncur. */
      void scBox.offsetHeight;
      scBox.classList.add('is-open');
    };

    var tutupSC = function () {
      scBox.classList.remove('is-open');
      /* hidden baru dipasang sesudah animasi keluar selesai. Diperiksa
         ulang di dalam supaya buka tutup cepat tidak menyembunyikan laci
         yang barusan dibuka lagi. */
      scJam = setTimeout(function () {
        if (!scBox.classList.contains('is-open')) scBox.hidden = true;
      }, 500);
    };

    var scPemicu = root.querySelectorAll('[data-kp-sc-open]');
    for (var sa = 0; sa < scPemicu.length; sa++) {
      scPemicu[sa].addEventListener('click', bukaSC);
    }

    var scTutup = scBox.querySelectorAll('[data-kp-sc-close]');
    for (var sb = 0; sb < scTutup.length; sb++) {
      scTutup[sb].addEventListener('click', tutupSC);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && scBox.classList.contains('is-open')) tutupSC();
    });
  }

  var tombolMundur = root.querySelector('[data-kp-prev]');
  if (tombolMundur && slides) {
    tombolMundur.addEventListener('click', function () {
      keSetTengah();
      var w = lebarSlide();
      var x = Math.round(slides.scrollLeft / w) * w - w;
      if (x < 0) x = 0;
      gulir(x);
    });
  }

  tandai();

  /* ---------- add to cart ---------- */

  if (form) {
    /* PENJAGA KETUKAN BERUNTUN.

       Handler ini menggantikan form bawaan theme, tapi dulu tidak ikut
       membawa penjaganya. Theme asli menonaktifkan tombol selama request
       berjalan, punya kita tidak, jadi setiap ketukan langsung jadi request
       baru yang berjalan bersamaan.

       Diukur di live, varian stok 2 dengan kebijakan DENY:
         6 ketukan   6 request /cart/add.js, keranjang berakhir x3
         10 ketukan  10 request add + 41 penyegaran keranjang = 51 request,
                     keranjang berakhir x3, bukan 1 dan bukan 10
       Request yang balapan saling menimpa, dan ikut lolos dari pengecekan
       stok, sampai x6 untuk barang yang stoknya cuma 2. Di HP dengan koneksi
       seluler, salah satu dari puluhan request itu gagal dan jatuh ke pesan
       "Gagal menambahkan ke keranjang".

       Sekarang satu penambahan berjalan sampai selesai, termasuk drawer
       terbuka, baru ketukan berikutnya diterima. Ketukan di tengah jalan
       diabaikan, bukan diantrekan. Variabel terpisah, bukan atc.disabled,
       karena disabled sudah dipakai untuk varian habis dan keduanya tidak
       boleh saling menghidupkan. */
    var sedangMenambah = false;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sedangMenambah) return;
      if (atc && atc.disabled) return;
      sedangMenambah = true;
      if (atc) atc.classList.add('is-loading');

      /* Jaring pengaman. fetch tidak punya batas waktu, dan di koneksi
         seluler request bisa menggantung lama. Tanpa ini penjaganya tidak
         pernah dilepas, dan tombol macet di status memuat sampai halaman
         dimuat ulang, yang lebih buruk daripada bug yang sedang diperbaiki. */
      var lepasPaksa = setTimeout(function () { selesai(); }, 12000);

      function selesai() {
        clearTimeout(lepasPaksa);
        sedangMenambah = false;
        if (atc) atc.classList.remove('is-loading');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          /* Dibaca sebagai teks dulu. Balasan yang bukan JSON, misalnya
             halaman batas request, dulu membuat r.json() melempar error dan
             pesan asli dari Shopify hilang tertelan pesan generik. */
          return r.text().then(function (t) {
            var j = null;
            try { j = JSON.parse(t); } catch (err) { /* bukan JSON */ }
            return { ok: r.ok, body: j };
          });
        })
        .then(function (hasil) {
          if (!hasil.ok) {
            selesai();
            var pesan = hasil.body && (hasil.body.description || hasil.body.message);
            window.alert(pesan || 'Gagal menambahkan ke keranjang.');
            return;
          }

          /* Buka cart drawer milik theme, jangan bikin sendiri.

             URUTANNYA PENTING, DAN INI SUMBER BUG "BARANG TIDAK MASUK".

             Drawer theme menyimpan salinan keranjang sendiri, lalu handler
             theme:cart:reload miliknya memilih jalur berdasarkan salinan itu:

               this.cart ? this.loadHTML() : this.init().then(() => this.loadHTML())

             Dulu di sini cuma theme:cart:reload yang dikirim. Karena tidak ada
             yang pernah mengisi this.cart, jalur init() yang diambil, dan jalur
             itu tidak pernah selesai merender. Hasilnya barang benar benar
             masuk keranjang (cart.js menghitungnya) tapi drawer tetap menulis
             "Your cart is empty", jadi terlihat seperti gagal sampai halaman
             dimuat ulang.

             Diukur langsung di live pada 375px: reload saja tidak pernah
             berubah walau ditunggu 2 detik, change lalu reload langsung benar.

             theme:cart:change juga yang memperbarui angka di ikon keranjang
             header dan progress bar gratis ongkir, dua duanya sebelumnya ikut
             basi. Isi detail.cart harus keranjang penuh, bukan balasan
             /cart/add.js yang cuma memuat item yang baru ditambahkan. */
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
            })
            .catch(function () { /* drawer tetap dibuka, isinya menyusul */ })
            .then(function () {
              try {
                document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));

                /* Tombol header ini TOGGLE, bukan "buka". Di desktop drawer
                   cuma selebar 481px, jadi tombol Add to Cart masih bisa
                   diklik di sebelahnya. Klik toggle saat drawer sudah terbuka
                   justru menutupnya, jadi pelanggan menambah barang lalu
                   drawer-nya hilang. Dicek dulu, diklik hanya kalau masih
                   tertutup. */
                var toggle = document.querySelector('[data-drawer-toggle="drawer-cart"]');
                var laci = document.querySelector('.cart__drawer');
                var sudahTerbuka = laci && laci.classList.contains('drawer--visible');
                if (toggle && !sudahTerbuka) toggle.click();
              } finally {
                /* Penjaga dan status memuat dilepas di sini, bukan begitu
                   /cart/add.js balas. Drawer baru benar benar terbuka sekitar
                   2 detik setelah tombol ditekan, karena masih ada /cart.js
                   lalu loadHTML milik theme. Kalau tombol sudah kembali normal
                   di detik pertama, layar diam tanpa tanda apa pun selama sisa
                   jeda itu, dan pelanggan mengira barangnya tidak masuk lalu
                   menekan lagi. finally supaya tombol tidak pernah macet walau
                   ada yang melempar error di atas. */
                selesai();
              }
            });
        })
        .catch(function () {
          selesai();
          window.alert('Gagal menambahkan ke keranjang.');
        });
    });
  }
})();

/* ============ LIGHTBOX GAMBAR, HANYA DI MOBILE ============

   Ketuk gambar produk, gambar terbuka penuh layar dan bisa di-pinch zoom.

   Memakai PhotoSwipe milik theme, bukan library baru. File-nya sudah ada
   (window.theme.assets.photoswipe), gayanya sudah di theme.css, dan markup
   akarnya dirender product-247.liquid lewat snippet zoom-pswp yang sama
   dengan yang dipakai PDP lama. Script-nya dimuat saat ketukan pertama,
   bukan saat halaman dibuka, supaya tidak menambah beban muat halaman.

   Dibatasi ke mobile sesuai permintaan. Di desktop galeri sudah menampilkan
   dua gambar besar berdampingan, dan perilakunya sudah disetujui.

   Indeks diambil dari data-kp-idx, BUKAN dari urutan slide di DOM. Galeri
   berputar dengan klon di depan dan belakang, jadi urutan DOM bukan urutan
   gambar. data-kp-media tidak bisa dipakai karena bikinKlon melepasnya. */
(function () {
  'use strict';

  var slides = document.querySelector('[data-kp-slides]');
  var dataEl = document.querySelector('[data-kp-zoom]');
  var akar = document.querySelector('.pswp');
  if (!slides || !dataEl || !akar) return;

  var items;
  try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!items || !items.length) return;

  var mq = window.matchMedia('(max-width: 767px)');

  var janji = null;
  function muatPswp() {
    if (janji) return janji;
    janji = new Promise(function (resolve, reject) {
      if (window.themePhotoswipe) { resolve(window.themePhotoswipe); return; }
      var url = window.theme && window.theme.assets && window.theme.assets.photoswipe;
      if (!url) { reject(); return; }
      var s = document.createElement('script');
      s.src = url;
      s.onload = function () {
        if (window.themePhotoswipe) resolve(window.themePhotoswipe); else reject();
      };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return janji;
  }

  function buka(i, gambar) {
    muatPswp().then(function (ps) {
      var PhotoSwipe = ps.PhotoSwipe.default || ps.PhotoSwipe;
      var UI = ps.PhotoSwipeUI.default || ps.PhotoSwipeUI;

      var galeri = new PhotoSwipe(akar, UI, items, {
        index: i,
        history: false,
        /* Tombol tombol ini tidak ada di markup zoom-pswp milik theme. */
        shareEl: false,
        fullscreenEl: false,
        zoomEl: false,
        /* Scroll halaman di belakang jangan menutup lightbox. Menutupnya
           lewat tombol silang atau tarik ke bawah, yang sudah bawaan. */
        closeOnScroll: false,
        bgOpacity: 1,
        showHideOpacity: true,
        /* Gambar membesar dari posisi gambar yang diketuk, bukan muncul
           begitu saja di tengah. */
        getThumbBoundsFn: function () {
          if (!gambar) return false;
          var r = gambar.getBoundingClientRect();
          var atas = window.pageYOffset || document.documentElement.scrollTop;
          return { x: r.left, y: r.top + atas, w: r.width };
        }
      });
      galeri.init();
    })['catch'](function () { /* diam: galeri tetap normal, cuma tanpa zoom */ });
  }

  /* Geseran jari untuk berpindah gambar tidak boleh ikut membuka lightbox.
     Di layar sentuh geseran memang tidak memicu click, tapi penjaga ini
     murah dan menutup kasus stylus serta mouse di layar sempit. */
  var turunX = 0, turunY = 0;
  slides.addEventListener('pointerdown', function (e) {
    turunX = e.clientX; turunY = e.clientY;
  });

  slides.addEventListener('click', function (e) {
    if (!mq.matches) return;
    var slide = e.target.closest && e.target.closest('.kit-pdp__slide');
    if (!slide) return;
    if (Math.abs(e.clientX - turunX) > 10 || Math.abs(e.clientY - turunY) > 10) return;

    var i = parseInt(slide.getAttribute('data-kp-idx'), 10);
    if (isNaN(i) || i < 0 || i >= items.length) return;

    e.preventDefault();
    buka(i, slide.querySelector('img'));
  });
})();
